import React from 'react';
import { Link } from 'react-router-dom';
import { SocialIcon } from 'react-social-icons';

const Footer = () => {
    return (
        <div className="bg-black   text-white ">
        <div className="grid lg:grid-cols-4 pl-10">

            <div className=" pt-5 font-semibold ">
                <p className="text-xl text-red-600">JOY BISWAS</p>
                <p className="pt-5">Passionate JavaScript Developer.And <br /> MERN STACK is My Core Expertise.</p>

            </div>


            <div className=" pt-5 font-semibold ">
                <p className="text-2xl pb-3">Expertise at</p>
                <p>JavaScript</p>
                <p>React Js</p>
                <p>Node Js</p>
                <p>Express Js</p>

            </div>
            <div className=" pt-5 font-semibold ">
                <p className="text-2xl pb-3">Contact Information</p>
                
                <p className="text-red-500"> <i class="fas fa-phone-alt"></i> +8801968047622</p>
                <p className="text-red-500"><i class="fas fa-envelope"></i> joy10311@gmail.com</p>
                <p className="text-red-500 mt-2">
            <SocialIcon url="https://www.linkedin.com/in/joy10311/" />
            <SocialIcon className=" mx-5" url="https://web.facebook.com/enjoy0069" />
            <SocialIcon  url="https://github.com/Joy10311" />
            <SocialIcon className=" mx-5" network="email" url="joy10311@gmail.com" /></p>
                

            </div>

            <div className=" pt-5 font-semibold ">
                <Link to="/about"><p className="text-2xl pb-3">Links</p></Link>
                <Link to="/about"><p>About Me</p></Link>
                <Link to="/projects"><p>Projects</p></Link>
                <Link to="/contact"><p>Contact</p></Link>
            </div>

        </div>
        <p className="text-center mt-3 pb-5">Copyright © 2016 - 2021. rights reserved-Joy_Biswas</p>
    </div>
    );
};

export default Footer;